class SectionCountdown extends HTMLElement {
  constructor() {
    super();

    this.initCountdown();
  }

  initCountdown() {
    const daysElement = this.querySelector(".countdown__time-value--days");
    const hoursElement = this.querySelector(".countdown__time-value--hours");
    const minutesElement = this.querySelector(".countdown__time-value--minutes");
    const secondsElement = this.querySelector(".countdown__time-value--seconds");

    const endTime = new Date(this.getAttribute("data-end")).getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        clearInterval(this.interval);
        daysElement.textContent = "00";
        hoursElement.textContent = "00";
        minutesElement.textContent = "00";
        secondsElement.textContent = "00";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysElement.textContent = String(days).padStart(2, "0");
      hoursElement.textContent = String(hours).padStart(2, "0");
      minutesElement.textContent = String(minutes).padStart(2, "0");
      secondsElement.textContent = String(seconds).padStart(2, "0");
    };
    updateCountdown();
    this.interval = setInterval(updateCountdown, 1000);
  }
}

customElements.define("section-countdown", SectionCountdown);

class Megamenu extends HTMLElement {
  constructor() {
    super();
    const mobileMenuLink = this.querySelector(".mobile-menu__nav-link");

    this.initMegamenu();
    this.handleLinkHover();
  }

  initMegamenu() {
    this.querySelectorAll(".header__megamenu-link[data-collection]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const collection = event.currentTarget.dataset.collection;
        this.querySelector(".header__megamenu-link.active")?.classList.remove("active");
        this.querySelector(`.header__megamenu-collection.active`)?.classList.remove("active");
        link.classList.add("active");
        this.querySelector(`.header__megamenu-collection[data-collection="${collection}"]`).classList.add("active");
      });
    });

    // Fix for Safari
    this.style.width = `${document.documentElement.clientWidth}px`;
    window.addEventListener("resize", () => {
      this.style.width = `${document.documentElement.clientWidth}px`;
    });
  }

  handleLinkHover() {
    document.querySelectorAll(".header__nav-item[data-has-submenu]").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        document.body.classList.add("muted-scrollable");
      });

      item.addEventListener("mouseleave", () => {
        document.body.classList.remove("muted-scrollable");
      });
    });
  }
}

customElements.define("header-megamenu", Megamenu);

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.link = this.querySelectorAll("[data-mobile-link-parent]");
    this.backSublist = this.querySelectorAll("[data-back-sublist]");
    this.sublist = this.querySelectorAll("[data-mobile-menu-sublist]");

    this.init();
  }

  init() {
    document.querySelectorAll("[data-toggle-mobile-menu]").forEach((button) => {
      button.addEventListener("click", () => this.toggleMenu());
    });

    this.link.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const parentIndex = event.currentTarget.getAttribute("data-mobile-link-parent");
        const sublist = this.querySelector(`[data-mobile-menu-sublist="${parentIndex}"]`);
        if (sublist) {
          sublist.classList.toggle("open");
          event.stopPropagation();
        }
      });
    });

    this.backSublist.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const sublist = event.currentTarget.closest(".mobile-menu__sublist");
        if (sublist) {
          sublist.classList.remove("open");
          event.stopPropagation();
        }
      });
    });
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.classList.add("open");
      document.body.classList.add("muted");
    } else {
      this.classList.remove("open");
      document.body.classList.remove("muted");
    }
  }
}

customElements.define("mobile-menu", MobileMenu);

class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.arrowBottom = this.getAttribute("data-arrows-position") === "bottom";
    document.addEventListener("DOMContentLoaded", () => {
      this.initSlider();
    });
  }
  initSlider() {
    if (this.arrowBottom) {
      this.config = {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: this.querySelector(".slider__btn--next--mobile"),
          prevEl: this.querySelector(".slider__btn--prev--mobile"),
        },
        breakpoints: {
          992: {
            spaceBetween: 30,
            slidesPerView: 3,
            navigation: {
              nextEl: this.querySelector(".slider__btn--next--desktop"),
              prevEl: this.querySelector(".slider__btn--prev--desktop"),
            },
          },
          1400: {
            spaceBetween: 30,
            slidesPerView: 4,
            navigation: {
              nextEl: this.querySelector(".slider__btn--next--desktop"),
              prevEl: this.querySelector(".slider__btn--prev--desktop"),
            },
          },
        },
      };
    } else {
      this.config = {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: this.querySelector(".slider__btn--next--mobile"),
          prevEl: this.querySelector(".slider__btn--prev--mobile"),
        },
        breakpoints: {
          992: {
            spaceBetween: 30,
            navigation: {
              nextEl: this.querySelector(".slider__btn--next--desktop"),
              prevEl: this.querySelector(".slider__btn--prev--desktop"),
            },
          },
        },
      };
    }
    this.swiper = new Swiper(this.querySelector(".swiper"), this.config);
  }
}

customElements.define("featured-products", FeaturedProducts);

class DropdownSelect extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".select__button");
    this.input = this.querySelector("input[data-select-value]");
    this.list = this.querySelector(".select__list");
    this.options = this.querySelectorAll(".select__option");
    this.init();
  }

  init() {
    this.button.addEventListener("click", () => {
      this.toggle();
    });

    this.addEventListener("click", (event) => {
      const option = event.target.closest(".select__option");
      if (option && this.list.contains(option)) {
        this.selectOption(option);
      }
    });

    document.addEventListener("click", (event) => {
      if (this.opened && !this.contains(event.target)) {
        this.toggle();
      }
    });
  }

  selectOption(option) {
    this.button.querySelector("[data-select-title]").textContent = option.textContent;
    this.input.value = option.getAttribute("data-select-value");
    this.toggle();
  }

  toggle() {
    this.opened = !this.opened;
    this.setAttribute("aria-expanded", this.opened);
  }
}

customElements.define("dropdown-select", DropdownSelect);

class Footer extends HTMLElement {
  constructor() {
    super();

    this.regions = this.querySelectorAll(".footer__region");
    this.platforms = this.querySelectorAll(".footer__platforms");
    this.init();
  }

  init() {
    this.regions.forEach((region) => {
      region.addEventListener("click", () => {
        this.toggleRegion(region);
      });
    });
  }

  toggleRegion(region) {
    const id = region.getAttribute("data-region-id");
    this.platforms.forEach((platform) => {
      if (platform.getAttribute("data-region-id") === id) {
        platform.classList.add("active");
      } else {
        platform.classList.remove("active");
      }
    });

    this.regions.forEach((region) => {
      if (region.getAttribute("data-region-id") === id) {
        region.classList.add("active");
      } else {
        region.classList.remove("active");
      }
    });
  }
}

customElements.define("footer-section", Footer);

class CollectionMain extends HTMLElement {
  constructor() {
    super();
    this.pageType = this.getAttribute("data-page-type");
    this.filterTitles = this.querySelectorAll(".filter__title");
    this.collectionHandle = this.getAttribute("data-handle");

    this.productsList = this.querySelector("[data-products-list]");
    this.productsListFiltered = this.querySelector("[data-products-list-filtered]");
    this.collectionProducts = this.querySelector("#CollectionProducts");
    this.sortInput = this.querySelector("[data-select-value]");
    this.clearFiltersButton = this.querySelectorAll("[data-clear-filters]");
    this.toggleDesktopFiltersEl = document.querySelectorAll("[data-toggle-desktop-filters]");
    this.toggleMobileFiltersEl = document.querySelectorAll("[data-toggle-mobile-filters]");

    this.showingFilteredCount = this.querySelectorAll("[data-current-count]");
    this.showingTotalCount = this.querySelectorAll("[data-total-count]");
    this.showingCurrentPage = this.querySelectorAll("[data-current-page]");
    this.showingTotalPages = this.querySelectorAll("[data-total-pages]");
    this.resetFiltersButton = this.querySelector(".filters__reset");

    this.filtersWrap = this.querySelector("[data-filters]");

    this.activeFiltersCount = 0;
    this.paginationContainer = this.querySelector(".pagination");
    this.paginatePerPage = 12;
    this.totalPages = 1;
    this.currentPage = 1;
    this.currentSort = this.getAttribute("data-sort");
    this.defaultSort = this.getAttribute("data-default-sort");
    this.filterParams = "";
    this.filterURL = "";
    this.ajaxTotalPages = this.getAttribute("data-ajax-count-pages") || 1;

    this.searchParam = "";
    this.searchValue = this.getAttribute("data-search") || "";

    this.filterMaxPrice = null;
    this.filterOnSale = false;
    this.filterPreOrder = false;
    this.filterInStock = false;
    this.filterProductType = [];

    this.mobileFiltersOpened = false;

    this.init();
    this.initParams();
  }

  init() {
    this.filterTitles.forEach((title) => {
      title.addEventListener("click", () => {
        let filter = title.closest(".filter");
        let expanded = filter.getAttribute("aria-expanded") === "true";
        filter.setAttribute("aria-expanded", !expanded);
      });
    });

    this.filtersWrap.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", () => {
        this.currentPage = 1;
        this.updateFilters();
      });
    });

    this.querySelectorAll("[data-single-option] input").forEach((option) => {
      option.addEventListener("click", (e) => {
        console.log(option.checked);
        const checked = option.checked;
        const value = option.value;
        const group = option.closest("[data-single-option]");
        if (checked) {
          group.querySelectorAll("input").forEach((input) => {
            let inputOption = input.value;
            if (inputOption !== value && input) {
              input.checked = false;
            }
          });
        }
      });
    });

    this.querySelectorAll(".collections-list__sort [data-select-value]").forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(() => {
          this.loadProducts();
        }, 100);
      });
    });

    this.clearFiltersButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.clearFilters();
      });
    });

    this.toggleDesktopFiltersEl.forEach((button) => {
      button.addEventListener("click", () => {
        this.toggleDesktopFilters();
      });
    });

    this.toggleMobileFiltersEl.forEach((button) => {
      button.addEventListener("click", () => {
        this.toggleMobileFilters();
      });
    });
  }

  toggleMobileFilters() {
    this.filtersWrap.classList.toggle("is-open");
    document.body.classList.toggle("muted");
    this.mobileFiltersOpened = !this.mobileFiltersOpened;
  }

  toggleDesktopFilters() {
    document.querySelector(".collection__toggle-desktop-filters").classList.toggle("is-open");
    this.classList.toggle("collection--filters-closed");
  }

  clearFilters() {
    this.filtersWrap.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.updateFilters();
  }

  initParams() {
    let urlParams = new URLSearchParams(window.location.search);
    let params = [];
    urlParams.forEach((value, key) => {
      params.push({ key: key, value: value });
    });
    params.forEach((param) => {
      let input = this.filtersWrap.querySelector(`input[name="${param.key}"][value="${param.value}"]`);
      if (input) {
        input.checked = true;
      }
    });
    this.updateFilters();
  }

  updateFilters() {
    this.activeFiltersCount = this.filtersWrap.querySelectorAll('input[type="checkbox"]:checked').length;
    this.filtersWrap.classList.add("loading");
    this.filterInStock = this.querySelector("#filter-availability-in-stock").checked;
    this.filterPreOrder = this.querySelector("#filter-availability-pre-order").checked;

    this.filterOnSale = this.querySelector("#filter-sale-on-sale").checked;

    this.filterProductType = [];

    this.querySelectorAll('input[name="product_type"]:checked').forEach((input) => {
      this.filterProductType.push(input.value);
    });

    console.log("this.filterProductType", this.filterProductType);

    this.filterMaxPrice = null;
    if (this.filtersWrap.querySelectorAll('input[name="price"]:checked').length) {
      this.filterMaxPrice = Math.max(
        ...Array.from(this.filtersWrap.querySelectorAll('input[name="price"]:checked')).map((input) => {
          let value = +input.value;
          return +value;
        })
      );
    }

    let urlParams = [];
    this.querySelectorAll("input[data-shopify-filter]:checked").forEach((input) => {
      urlParams.push(`${input.getAttribute("name")}=${input.value}`);
    });
    this.filterParams = `${urlParams.join("&")}`;
    this.loadProducts();
    this.updateTypesUrls();
  }

  updateTypesUrls() {
    this.querySelectorAll("[data-filter-type-link]").forEach((link) => {
      const url = link.getAttribute("href");
      link.setAttribute(
        "href",
        `${url}${this.filterParams || this.currentSort != this.defaultSort ? "?" : ""}${this.filterParams}${this.currentSort != this.defaultSort ? "&sort_by=" + this.currentSort : ""}`
      );
    });
  }

  loadProducts() {
    // return;
    this.productsList.innerHTML = "";
    this.currentSort = this.sortInput.value;
    this.ajaxLoadProducts(1);
  }

  ajaxLoadProducts(i) {
    if (this.pageType === "search") {
      this.filterURL = `${location.pathname}?q=${this.searchValue}&${this.filterParams}&sort_by=${this.currentSort}&type=product&view=ajax`;
      this.visibleURL = `${location.pathname}${this.searchValue || this.filterParams || this.currentSort != this.defaultSort ? "?" : ""}${this.filterParams}${this.searchValue ? "&q=" + this.searchValue + "&type=product" : ""}${this.currentSort != this.defaultSort ? "&sort_by=" + this.currentSort : ""}`;
      window.history.replaceState({}, "", this.visibleURL);
    } else {
      this.filterURL = `${location.pathname}?${this.filterParams}&sort_by=${this.currentSort}&view=ajax&page=${i}`;
      this.visibleURL = `${location.pathname}${this.filterParams || this.currentSort != this.defaultSort ? "?" : ""}${this.filterParams}${this.currentSort != this.defaultSort ? "&sort_by=" + this.currentSort : ""}`;
      window.history.replaceState({}, "", this.visibleURL);
    }
    fetch(this.filterURL)
      .then((response) => response.text())
      .then((data) => {
        let html_div = document.createElement("div");
        html_div.innerHTML = data;
        let html_dom = "";
        if (this.pageType == "search") {
          html_dom = html_div.querySelector("[data-search-results]").innerHTML;
        } else {
          html_dom = html_div.querySelector("#CollectionProducts").innerHTML;
        }
        this.productsList.innerHTML += html_dom;
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        i++;
        if (i <= this.ajaxTotalPages) {
          this.ajaxLoadProducts(i);
        } else {
          this.filterProducts();
        }
      });
  }

  filterProducts() {
    // for Product Type we are using data-collections
    this.currentPage = 1;
    this.productsListFiltered.innerHTML = "";
    this.productsList.querySelectorAll(".collection__product").forEach((product) => {
      const price = +product.getAttribute("data-price");
      const available = product.getAttribute("data-available") == "true";
      const sale = product.getAttribute("data-sale") == "true";
      const preOrder = product.getAttribute("data-preorder") == "true";
      const collectionsAttr = product.getAttribute("data-collections");
      const collections = collectionsAttr ? collectionsAttr.split(",") : [];
      const isB2BProduct = product.getAttribute("data-b2b-product") == "true";
      const isB2BCustomer = window.isB2B || false;

      if (isB2BProduct && !isB2BCustomer) return;
      if (this.filterInStock && (preOrder || !available)) return;
      if (this.filterPreOrder && !preOrder) return;
      if (this.filterOnSale && !sale) return;
      if (this.filterMaxPrice && price > this.filterMaxPrice) return;
      if (this.filterProductType.length && !this.filterProductType.some((type) => collections.includes(type))) return;

      this.productsListFiltered.appendChild(product.cloneNode(true));
    });
    this.paginateProducts();
  }

  paginateProducts() {
    let products = this.productsListFiltered.querySelectorAll(".collection__product");
    this.classList.remove("collection--empty");
    this.totalPages = Math.ceil(products.length / this.paginatePerPage);

    // Display products for the current page
    let start = (this.currentPage - 1) * this.paginatePerPage;
    let end = start + this.paginatePerPage;
    let visibleProducts = Array.from(products).slice(start, end);

    this.collectionProducts.innerHTML = "";
    visibleProducts.forEach((product) => {
      this.collectionProducts.appendChild(product.cloneNode(true));
    });

    // Render pagination
    this.renderPagination();
  }

  renderPagination() {
    if (!this.paginationContainer) {
      this.paginationContainer = document.createElement("div");
      this.paginationContainer.className = "pagination original_pagination";
      this.collectionProducts.parentNode.appendChild(this.paginationContainer);
    }

    let paginationHTML = `<div class="pagination__inner">`;

    let maxVisiblePages = 4;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    paginationHTML += `<button class="pagination__btn slider__btn slider__btn--prev pagination__prev" rel="prev" aria-label="Previous" data-page="${
      this.currentPage - 1
    }" ${this.currentPage > 1 ? "" : "disabled"} href="#"><svg xmlns="http://www.w3.org/2000/svg" class=" icon icon-arrow-right" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M27.7075 16.7076L18.7075 25.7076C18.5199 25.8952 18.2654 26.0006 18 26.0006C17.7346 26.0006 17.4801 25.8952 17.2925 25.7076C17.1049 25.5199 16.9994 25.2654 16.9994 25.0001C16.9994 24.7347 17.1049 24.4802 17.2925 24.2926L24.5863 17.0001H5C4.73478 17.0001 4.48043 16.8947 4.29289 16.7072C4.10536 16.5196 4 16.2653 4 16.0001C4 15.7349 4.10536 15.4805 4.29289 15.293C4.48043 15.1054 4.73478 15.0001 5 15.0001H24.5863L17.2925 7.70757C17.1049 7.51993 16.9994 7.26543 16.9994 7.00007C16.9994 6.7347 17.1049 6.48021 17.2925 6.29257C17.4801 6.10493 17.7346 5.99951 18 5.99951C18.2654 5.99951 18.5199 6.10493 18.7075 6.29257L27.7075 15.2926C27.8005 15.3854 27.8742 15.4957 27.9246 15.6171C27.9749 15.7385 28.0008 15.8687 28.0008 16.0001C28.0008 16.1315 27.9749 16.2616 27.9246 16.383C27.8742 16.5044 27.8005 16.6147 27.7075 16.7076Z" fill="currentColor"></path>
    </svg></button>`;

    paginationHTML += `<div class="pagination__nav">`;

    if (startPage > 1) {
      paginationHTML += `<a href="#" data-page="1" class="pagination__nav-item" aria-label="Navigate to page 1">1</a>`;
      if (startPage > 2) {
        paginationHTML += `<span class="pagination__nav-item">...</span>`;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i === this.currentPage) {
        paginationHTML += `<span class="pagination__nav-item is-active">${i}</span>`;
      } else {
        paginationHTML += `<a href="#" data-page="${i}" class="pagination__nav-item" aria-label="Navigate to page ${i}">${i}</a>`;
      }
    }

    if (endPage < this.totalPages) {
      if (endPage < this.totalPages - 1) {
        paginationHTML += `<span class="pagination__nav-item">...</span>`;
      }
      paginationHTML += `<a href="#" data-page="${this.totalPages}" class="pagination__nav-item" aria-label="Navigate to page ${this.totalPages}">${this.totalPages}</a>`;
    }

    paginationHTML += `</div>`;

    paginationHTML += `<button class="pagination__btn slider__btn slider__btn--next pagination__next" rel="next" aria-label="Next" data-page="${
      this.currentPage + 1
    }" ${
      this.currentPage < this.totalPages ? "" : "disabled"
    } href="#"><svg xmlns="http://www.w3.org/2000/svg" class=" icon icon-arrow-right" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M27.7075 16.7076L18.7075 25.7076C18.5199 25.8952 18.2654 26.0006 18 26.0006C17.7346 26.0006 17.4801 25.8952 17.2925 25.7076C17.1049 25.5199 16.9994 25.2654 16.9994 25.0001C16.9994 24.7347 17.1049 24.4802 17.2925 24.2926L24.5863 17.0001H5C4.73478 17.0001 4.48043 16.8947 4.29289 16.7072C4.10536 16.5196 4 16.2653 4 16.0001C4 15.7349 4.10536 15.4805 4.29289 15.293C4.48043 15.1054 4.73478 15.0001 5 15.0001H24.5863L17.2925 7.70757C17.1049 7.51993 16.9994 7.26543 16.9994 7.00007C16.9994 6.7347 17.1049 6.48021 17.2925 6.29257C17.4801 6.10493 17.7346 5.99951 18 5.99951C18.2654 5.99951 18.5199 6.10493 18.7075 6.29257L27.7075 15.2926C27.8005 15.3854 27.8742 15.4957 27.9246 15.6171C27.9749 15.7385 28.0008 15.8687 28.0008 16.0001C28.0008 16.1315 27.9749 16.2616 27.9246 16.383C27.8742 16.5044 27.8005 16.6147 27.7075 16.7076Z" fill="currentColor"></path>
    </svg></button>`;

    paginationHTML += `</div>`;
    this.paginationContainer.innerHTML = paginationHTML;

    // Add event listeners for pagination links
    this.paginationContainer.querySelectorAll("[data-page]").forEach((link) => {
      link.addEventListener("click", (e) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        e.preventDefault();
        this.currentPage = parseInt(link.getAttribute("data-page"), 10);
        this.paginateProducts();
      });
    });
    this.updateShowingString();
    this.filtersWrap.classList.remove("loading");
  }

  updateShowingString() {
    const productsCount = this.productsListFiltered.querySelectorAll(".collection__product").length;
    this.showingTotalCount.forEach((item) => {
      item.innerHTML = this.productsListFiltered.querySelectorAll(".collection__product").length;
    });
    this.showingFilteredCount.forEach((item) => {
      item.innerHTML = `${(this.currentPage - 1) * this.paginatePerPage + 1} - ${Math.min(this.currentPage * this.paginatePerPage, this.productsListFiltered.querySelectorAll(".collection__product").length)}`;
    });
    this.showingCurrentPage.forEach((item) => {
      item.innerHTML = this.currentPage;
    });
    this.showingTotalPages.forEach((item) => {
      item.innerHTML = this.totalPages;
    });

    if (productsCount > 0) {
      this.classList.remove("collection--empty");
    } else {
      this.classList.add("collection--empty");
    }

    if (this.activeFiltersCount) {
      this.resetFiltersButton.classList.add("is-active");
    } else {
      this.resetFiltersButton.classList.remove("is-active");
    }
  }
}

customElements.define("collection-main", CollectionMain);

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".marquee-content")) {
    const marqueeContent = document.querySelector(".marquee-content");
    const marqueeWrapper = marqueeContent.parentElement;
    const clone = marqueeContent.cloneNode(true);
    marqueeWrapper.appendChild(clone);
  }
});

// Quantity Selector
let QuantitySelector = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector("input");
    this.notification = this.closest(".product-info__quantity-selector")?.querySelector(".quantity-max-notification");
    this.querySelector("button:first-of-type").addEventListener("click", this.stepDown.bind(this), {
      signal: this._abortController.signal,
    });
    this.querySelector("button:last-of-type").addEventListener("click", this.stepUp.bind(this), {
      signal: this._abortController.signal,
    });
    this.inputElement.addEventListener("change", this.checkMax.bind(this), {
      signal: this._abortController.signal,
    });
    this.updateMaxFromCart();
  }
  async updateMaxFromCart() {
    const variantId = this.inputElement.dataset.variantId;
    const dataMax = parseInt(this.inputElement.dataset.max);
    if (!variantId || isNaN(dataMax)) return;
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
      const cartQty = cartItem ? cartItem.quantity : 0;
      const availableMax = Math.max(0, dataMax - cartQty);
      this.inputElement.max = availableMax;
      if (parseInt(this.inputElement.value) > availableMax) {
        this.inputElement.value = availableMax;
      }
      if (availableMax === 0 && this.notification) {
        this.notification.classList.add("is-visible");
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  }
  stepDown() {
    this.inputElement.stepDown();
    this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
  }
  stepUp() {
    this.inputElement.stepUp();
    this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
  }
  checkMax() {
    const max = parseInt(this.inputElement.max);
    const value = parseInt(this.inputElement.value);
    if (this.notification && max && value >= max) {
      this.notification.classList.add("is-visible");
      clearTimeout(this._notificationTimeout);
      this._notificationTimeout = setTimeout(() => {
        this.notification.classList.remove("is-visible");
      }, 3000);
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
    clearTimeout(this._notificationTimeout);
  }
};

let QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    this.addEventListener("focus", this.select);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric =
      (typeof quantity === "number" || (typeof quantity === "string" && quantity.trim() !== "")) && !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
    if (!this.checkValidity()) {
      this.stepDown();
    }
  }
  _onValueInput() {
    this.quantity = this.value;
    this.style.setProperty("--quantity-input-characters-count", `${this.value.toString().length}ch`);
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = this.min || 1;
    }
    if (!this.checkValidity()) {
      this.stepDown();
    }
    this.style.setProperty("--quantity-input-characters-count", `${this.value.toString().length}ch`);
  }
};
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}

class Blog extends HTMLElement {
  constructor() {
    super();

    this.featuredCount = document.querySelector("[data-featured-count]");
    this.featuredList = this.querySelector(".blog__featured-list");
    this.swiper = null;
    this.currentPage = 1;
    this.paginatePerPage = 12;
    this.totalPages = 1;
    this.articlesGrid = this.querySelector("#blogArticles");
    this.articlesList = document.querySelector("[data-articles-list]");
    this.articlesListFiltered = this.querySelector("[data-filtered-articles-list]");
    this.paginationContainer = this.querySelector(".pagination");
    this.emptyState = this.querySelector(".blog__empty");
    this.blogHandle = this.getAttribute("data-blog-handle") || "news";
    this.visibleURL = `/blogs/${this.blogHandle}`;
    this.categories = [];
    this.topPosition = this.articlesGrid.offsetTop;

    this.filterValue = this.querySelector("[data-select-value]");
    this.searchInput = this.querySelector("[data-search-input]");

    document.addEventListener("DOMContentLoaded", () => {
      this.init();
      this.updateFeaturedCount();
      this.loadArticles();

      this.filterByParams();

      this.searchInput.addEventListener("input", () => {
        this.filterBlog();
      });
    });
  }

  init() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.featuredList, {
      slidesPerView: 1,
      spaceBetween: 12,
      slideVisibleClass: "blog__featured-slide--visible",
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });

    this.swiper.on("init", () => {
      this.updateFeaturedCount();
    });
    this.swiper.on("slideChange", () => {
      this.updateFeaturedCount();
    });
  }

  handleize(value) {
    return value.toLowerCase().replace(/\s+/g, "-");
  }

  filterByParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get("category");
    const search = urlParams.get("q");
    const page = urlParams.get("page");

    if (category) {
      this.filterValue.value = this.handleize(category);
      this.querySelector("[data-select-title]").textContent = category.replace(/-/g, " ");
    }

    if (search) {
      this.searchInput.value = decodeURIComponent(search);
    }

    if (category || search) {
      setTimeout(() => {
        this.filterBlog();
        if (page && !isNaN(Number(page))) {
          this.currentPage = parseInt(page, 10);
          this.paginateArticles();
        }
      }, 1000);
    } else if (page && !isNaN(Number(page))) {
      // If page param exists but no filters/search, just jump to correct page on load
      setTimeout(() => {
        this.currentPage = parseInt(page, 10);
        this.paginateArticles();
      }, 1000);
    }
  }

  loadArticles() {
    fetch(`/blogs/${this.blogHandle}?view=ajax`)
      .then((response) => response.text())
      .then((data) => {
        let html_div = document.createElement("div");
        html_div.innerHTML = data;
        let html_dom = "";
        html_dom = html_div.querySelector("#blogArticles").innerHTML;
        this.articlesList.innerHTML += html_dom;
        this.articlesListFiltered.innerHTML += html_dom;
        this.categories = html_div.querySelector("[data-categories]").getAttribute("data-categories").split(",");
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        this.paginateArticles();
        this.insertCategories();
      });
  }

  insertCategories() {
    let uniqueCategories = [...new Set(this.categories)].filter((category) => category.trim() !== "");
    if (!uniqueCategories.length) return;
    this.querySelector(".select-wrap").style.display = "flex";
    let selectList = this.querySelector(".select__list");
    uniqueCategories.forEach((category) => {
      let button = document.createElement("button");
      button.className = "select__option";
      button.setAttribute("data-select-value", category.toLowerCase().replace(/\s+/g, "-"));
      button.textContent = category;
      selectList.appendChild(button);
    });

    this.querySelectorAll(".select__option").forEach((option) => {
      option.addEventListener("click", () => {
        setTimeout(() => {
          this.filterBlog();
        }, 100);
      });
    });
  }

  updateFeaturedCount() {
    let visibleSlides = this.querySelectorAll(".blog__featured-slide--visible");
    let currentIndex =
      visibleSlides.length > 0 ? visibleSlides[visibleSlides.length - 1].getAttribute("data-index") : 1;
    this.featuredCount.textContent = currentIndex;
  }

  filterBlog() {
    let filter = this.filterValue.value;
    let searchTerm = this.searchInput.value.toLowerCase();

    // Building URL params
    let params = [];
    if (searchTerm !== "") {
      params.push(`q=${encodeURIComponent(searchTerm)}`);
    }
    if (filter !== "all") {
      params.push(`category=${encodeURIComponent(filter)}`);
    }
    // Always start from the first page for a new filter/search
    if (this.currentPage > 1) {
      this.currentPage = 1;
    }
    // Construct the visible URL (but do not add page=1, page is omitted for "first" page)
    this.visibleURL = `${location.pathname}${params.length ? "?" + params.join("&") : ""}`;

    history.replaceState(null, "", this.visibleURL);

    this.articlesListFiltered.innerHTML = "";

    this.articlesList.querySelectorAll(".article-card").forEach((article) => {
      let category = article.getAttribute("data-category") || "";
      let title = article.getAttribute("data-title").toLowerCase() || "";
      let excerpt = article.getAttribute("data-excerpt").toLowerCase() || "";

      let matchesFilter = filter === "all" || category.toLowerCase().replace(/\s+/g, "-") === filter;
      let matchesSearch = title.includes(searchTerm) || excerpt.includes(searchTerm) || searchTerm === "";

      if (matchesFilter && matchesSearch) {
        this.articlesListFiltered.appendChild(article.cloneNode(true));
      }
    });

    this.paginateArticles();
  }

  paginateArticles() {
    let articles = this.articlesListFiltered.querySelectorAll(".article-card");
    this.totalPages = Math.ceil(articles.length / this.paginatePerPage);

    // Clamp currentPage to valid range
    if (this.currentPage < 1) this.currentPage = 1;
    if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

    // Display articles for the current page
    let start = (this.currentPage - 1) * this.paginatePerPage;
    let end = start + this.paginatePerPage;
    let visibleArticles = Array.from(articles).slice(start, end);

    this.articlesGrid.innerHTML = "";
    visibleArticles.forEach((article) => {
      this.articlesGrid.appendChild(article.cloneNode(true));
    });

    // Update URL to reflect page param
    this.updatePageUrl();

    // Render pagination
    this.renderPagination();

    if (articles.length === 0) {
      this.emptyState.style.display = "block";
      this.paginationContainer.style.display = "none";
    } else {
      this.emptyState.style.display = "none";
      this.paginationContainer.style.display = "flex";
    }
  }

  renderPagination() {
    if (!this.paginationContainer) {
      this.paginationContainer = document.createElement("div");
      this.paginationContainer.className = "pagination original_pagination";
      this.articlesGrid.parentNode.appendChild(this.paginationContainer);
    }

    let paginationHTML = `<div class="pagination__inner">`;

    let maxVisiblePages = 4;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    paginationHTML += `<button class="pagination__btn slider__btn slider__btn--prev pagination__prev" rel="prev" aria-label="Previous" data-page="${
      this.currentPage - 1
    }" ${
      this.currentPage > 1 ? "" : "disabled"
    } href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.2806 11.4694C16.3504 11.539 16.4057 11.6217 16.4434 11.7128C16.4812 11.8038 16.5006 11.9014 16.5006 12C16.5006 12.0986 16.4812 12.1962 16.4434 12.2872C16.4057 12.3783 16.3504 12.461 16.2806 12.5306L13.2806 15.5306C13.1399 15.6714 12.949 15.7504 12.75 15.7504C12.551 15.7504 12.3601 15.6714 12.2194 15.5306C12.0786 15.3899 11.9996 15.199 11.9996 15C11.9996 14.801 12.0786 14.6101 12.2194 14.4694L13.9397 12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H13.9397L12.2194 9.53063C12.0786 9.38989 11.9996 9.19902 11.9996 9C11.9996 8.80098 12.0786 8.61011 12.2194 8.46937C12.3601 8.32864 12.551 8.24958 12.75 8.24958C12.949 8.24958 13.1399 8.32864 13.2806 8.46937L16.2806 11.4694Z" fill="currentColor"/>
  </svg></button>`;

    paginationHTML += `<div class="pagination__nav">`;

    if (startPage > 1) {
      paginationHTML += `<a href="#" data-page="1" class="pagination__nav-item" aria-label="Navigate to page 1">1</a>`;
      if (startPage > 2) {
        paginationHTML += `<span class="pagination__nav-item">...</span>`;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i === this.currentPage) {
        paginationHTML += `<span class="pagination__nav-item is-active">${i}</span>`;
      } else {
        paginationHTML += `<a href="#" data-page="${i}" class="pagination__nav-item" aria-label="Navigate to page ${i}">${i}</a>`;
      }
    }

    if (endPage < this.totalPages) {
      if (endPage < this.totalPages - 1) {
        paginationHTML += `<span class="pagination__nav-item">...</span>`;
      }
      paginationHTML += `<a href="#" data-page="${this.totalPages}" class="pagination__nav-item" aria-label="Navigate to page ${this.totalPages}">${this.totalPages}</a>`;
    }

    paginationHTML += `</div>`;

    paginationHTML += `<button class="pagination__btn slider__btn slider__btn--next pagination__next" rel="next" aria-label="Next" data-page="${
      this.currentPage + 1
    }" ${
      this.currentPage < this.totalPages ? "" : "disabled"
    } href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM16.2806 11.4694C16.3504 11.539 16.4057 11.6217 16.4434 11.7128C16.4812 11.8038 16.5006 11.9014 16.5006 12C16.5006 12.0986 16.4812 12.1962 16.4434 12.2872C16.4057 12.3783 16.3504 12.461 16.2806 12.5306L13.2806 15.5306C13.1399 15.6714 12.949 15.7504 12.75 15.7504C12.551 15.7504 12.3601 15.6714 12.2194 15.5306C12.0786 15.3899 11.9996 15.199 11.9996 15C11.9996 14.801 12.0786 14.6101 12.2194 14.4694L13.9397 12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H13.9397L12.2194 9.53063C12.0786 9.38989 11.9996 9.19902 11.9996 9C11.9996 8.80098 12.0786 8.61011 12.2194 8.46937C12.3601 8.32864 12.551 8.24958 12.75 8.24958C12.949 8.24958 13.1399 8.32864 13.2806 8.46937L16.2806 11.4694Z" fill="currentColor"/>
      </svg></button>`;

    paginationHTML += `</div>`;
    this.paginationContainer.innerHTML = paginationHTML;

    // Add event listeners for pagination links
    this.topPosition = this.articlesGrid.offsetTop;
    this.paginationContainer.querySelectorAll("[data-page]").forEach((link) => {
      link.addEventListener("click", (e) => {
        window.scrollTo({
          top: this.topPosition,
          behavior: "smooth",
        });
        e.preventDefault();
        this.currentPage = parseInt(link.getAttribute("data-page"), 10);
        this.paginateArticles();
      });
    });
  }

  updatePageUrl() {
    // Update the URL to reflect the current page number and keep other query params
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Remove "page" param if on page 1, or set page X if X > 1
    if (this.currentPage > 1) {
      params.set("page", this.currentPage.toString());
    } else {
      params.delete("page");
    }

    // If filters/search change, we already set visibleURL in filterBlog
    // Here, update the URL with the new page param (preserving filters/search)
    let baseUrl = `${location.pathname}${params.toString() ? "?" + params.toString() : ""}`;
    history.replaceState(null, "", baseUrl);
  }
}

customElements.define("section-blog", Blog);

class CollectionsList extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector("#searchInput");
    this.sortInput = this.querySelector("#sortInput");
    this.sortWrap = this.querySelector(".collections-list__sort");
    this.init();
  }

  init() {
    this.appendExtension();
    this.searchInput.addEventListener("input", this.handleSearch.bind(this));
    this.sortInput.addEventListener("change", this.handleSort.bind(this));
    this.sortWrap.querySelectorAll("[data-select-value]").forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(() => {
          this.handleSort();
        }, 1);
      });
    });
  }

  appendExtension() {
    let startIndex = 50;
    const extensions = document.querySelectorAll("[data-collections-list-extension]");
    if (extensions.length) {
      extensions.forEach((extension) => {
        const items = extension.querySelectorAll(".collections-list__item");
        items.forEach((item) => {
          item.setAttribute("data-index", startIndex);
          this.querySelector(".collections-list__grid").appendChild(item);
          startIndex++;
        });
        startIndex += 50;
      });
    }
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm.length > 3) {
      const items = this.querySelectorAll(".collections-list__item");
      items.forEach((item) => {
        const title = item.getAttribute("data-title").toLowerCase();
        item.style.display = title.includes(searchTerm) ? "flex" : "none";
      });
    } else {
      const items = this.querySelectorAll(".collections-list__item");
      items.forEach((item) => {
        item.style.display = "flex";
      });
    }
  }

  handleSort() {
    const sortBy = this.sortInput.value;
    const items = this.querySelectorAll(".collections-list__item");
    const sortedItems = Array.from(items).sort((a, b) => {
      if (sortBy === "alphabetically-a-z") {
        const titleA = a.getAttribute("data-title").toLowerCase();
        const titleB = b.getAttribute("data-title").toLowerCase();
        return titleA.localeCompare(titleB);
      } else if (sortBy === "alphabetically-z-a") {
        const titleA = a.getAttribute("data-title").toLowerCase();
        const titleB = b.getAttribute("data-title").toLowerCase();
        return titleB.localeCompare(titleA);
      } else if (sortBy === "featured") {
        const indexA = parseInt(a.getAttribute("data-index"), 10);
        const indexB = parseInt(b.getAttribute("data-index"), 10);
        return indexA - indexB;
      }
      return 0;
    });
    sortedItems.forEach((item) => {
      item.parentElement.appendChild(item);
    });
  }
}

customElements.define("collections-list", CollectionsList);

class ArticleSection extends HTMLElement {
  constructor() {
    super();
    this.category = this.getAttribute("data-category");
    this.blogHandle = this.getAttribute("data-blog");
    this.categories = [];

    this.categoriesList = this.querySelector("[data-categories-list]");
    this.categoriesWrap = this.querySelector("[data-categories-wrap]");

    this.init();
    this.appendBlocks();
    this.renderImagesAlt();
    this.loadCategories();
    this.renderAnchors();
  }

  init() {}

  renderAnchors() {
    const content = this.querySelector("[data-content]");
    const tableList = this.querySelector("[data-table-list]");
    const tableContainer = this.querySelector("[data-table-of-contents]");

    if (!content || !tableList) return;

    const headings = content.querySelectorAll("h2");
    if (!headings.length) {
      tableContainer.style.display = "none";
      return;
    }

    tableContainer.classList.add("active");
    const buttons = [];
    headings.forEach((heading, index) => {
      const id = `heading-${index + 1}`;
      heading.setAttribute("id", id);
      const button = this.createAnchorButton(heading.textContent, id, tableList, buttons);
      tableList.appendChild(button);
      buttons.push(button);
    });

    const setActiveOnScroll = () => this.updateActiveAnchor(headings, buttons);

    window.addEventListener("scroll", setActiveOnScroll, { passive: true });
    setActiveOnScroll();
  }

  createAnchorButton(text, id, tableList, buttons) {
    const button = document.createElement("button");
    button.className = "article__table-link-item";
    const span = document.createElement("span");
    span.textContent = text;
    button.appendChild(span);
    button.onclick = () => {
      const headingElement = document.getElementById(id);
      const offset = 100;
      const elementPosition = headingElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    };
    return button;
  }

  updateActiveAnchor(headings, buttons) {
    const scrollPosition = window.scrollY || window.pageYOffset;
    const offset = 200;
    let activeIndex = -1;
    headings.forEach((heading, i) => {
      const rect = heading.getBoundingClientRect();
      const top = rect.top + window.scrollY - offset;
      if (scrollPosition >= top) {
        activeIndex = i;
      }
    });
    buttons.forEach((btn, i) => btn.classList.toggle("active", i === activeIndex));
  }

  renderImagesAlt() {
    this.querySelectorAll("img").forEach((img) => {
      let alt = img.getAttribute("alt");
      if (alt) {
        img.insertAdjacentHTML("afterend", `<span class="img-alt">${alt}</span>`);
      }
    });
  }

  appendBlocks() {
    const blocksContainer = this.querySelector("[data-article-blocks]");
    const contentContainer = this.querySelector("[data-content]");

    if (blocksContainer && contentContainer) {
      blocksContainer.querySelectorAll("[data-block-id]").forEach((block) => {
        let dataBlockId = block.getAttribute("data-block-id");
        contentContainer.querySelectorAll(`[data-block-id="${dataBlockId}"]`).forEach((item) => {
          item.innerHTML = block.outerHTML;
        });
      });
    }
  }

  loadCategories() {
    fetch(`/blogs/${this.blogHandle}?view=ajax`)
      .then((response) => response.text())
      .then((data) => {
        let html_div = document.createElement("div");
        html_div.innerHTML = data;
        if (html_div.querySelector("[data-categories]").getAttribute("data-categories")) {
          this.categories = html_div.querySelector("[data-categories]").getAttribute("data-categories").split(",");
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        this.renderCategories();
      });
  }

  renderCategories() {
    if (this.categories.length) {
      console.log("categories", this.categories);
      this.categoriesList.innerHTML = this.categories
        .map(
          (category) =>
            `<a href="/blogs/${this.blogHandle}?category=${category}" class="tag tag--large">${category}</a>`
        )
        .join("");
      this.categoriesWrap.style.display = "block";
    }
  }
}

customElements.define("article-section", ArticleSection);

document.addEventListener("DOMContentLoaded", () => {
  const draftOrderBtn = document.querySelectorAll("[data-create-draft]");
  const apiUrl = 'https://faas-fra1-afec6ce7.doserverless.co/api/v1/web/fn-5748b803-616c-4545-acec-c19d12f859e1/node-fetch/test1'
  const draftOrderSuccess = document.querySelectorAll("[data-draft-success]");
  const draftOrderError = document.querySelectorAll("[data-draft-error]");
  const draftOrderLoading = document.querySelectorAll("[data-draft-loading]");
  if (draftOrderBtn.length) {
    draftOrderBtn.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const customerId = +btn.getAttribute("data-create-draft");
        
        // Add loading state
        btn.disabled = true;

        draftOrderLoading.forEach(loading => {
          loading.style.display = 'block';
        });
        fetch('/cart.js').then(response => response.json()).then(cart => {
          fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              customer_id: customerId,
              line_items: cart.items.map(item => ({
                variant_id: item.id,
                quantity: item.quantity
              }))
            })
          }).then(response => response.json()).then(data => {
            console.log("data", data);
            // Remove loading state
            btn.disabled = false;

            draftOrderLoading.forEach(loading => {
              loading.style.display = 'none';
            });
            
            // Check if response contains draft_order object
            if (data && data.draft_order) {
              draftOrderSuccess.forEach(success => {
                success.style.display = 'block';
              });
              draftOrderBtn.forEach(btn => {
                btn.style.display = 'none';
              });
            } else {
              draftOrderError.forEach(error => {
                error.style.display = 'block';
              });
            }
          }).catch(error => {
            console.error("Error creating draft order");
            // Remove loading state and set error
            btn.disabled = false;
            draftOrderError.forEach(error => {
              error.style.display = 'block';
            });
          });
        }).catch(error => {
          console.error("Error fetching cart:", error);
        });
      });
    });
  }
});